import { PaginationSearchParams } from '@/types/pagination';
import { PaymentStatus } from '@/types/payment';

export enum PaymentPageStage {
  ALL = 'all',
  AWAITING_PAYMENT = 'awaiting_payment',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  COMPLETED = 'completed',
}

export enum PaymentPageTab {
  TO_PAY = 'to_pay',
  TO_RECEIVE = 'to_receive',
}

export type PaymentsSearchParams = PaginationSearchParams & {
  status?: PaymentStatus | PaymentStatus[];
  term?: string;
  tab?: PaymentPageTab;
  educationProvider?: string | string[];
  stage?: PaymentPageStage;
};
